module.exports = __webpack_public_path__ + "static/media/p13.e332d889.jpg";